<template>
  <v-layout>
    <v-col v-if="Discovery.isForm" cols :sm="12" class="pa-0">
      <v-form v-model="Discovery.isValid" ref="form">
        <v-card flat class="pt-5">
          <v-layout align-center class="px-3">
            <h2>{{ $t("menu.discovery") }}</h2>
            <v-spacer></v-spacer>
            <v-icon @click="_fnReset()" color="primary"> mdi-close </v-icon>
          </v-layout>
          <v-card-text>
            <v-row>
              <v-col cols :sm="6" class="py-0">
                <v-text-field
                  color="primary"
                  :rules="[Rules.required]"
                  v-model="Discovery.obj.titleVI"
                >
                  <template #label>
                    {{ $t(`table.title`) + " (VI)" }}
                    <span class="red--text"><b>*</b></span>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols :sm="6" class="py-0">
                <v-text-field
                  color="primary"
                  :rules="[Rules.required]"
                  v-model="Discovery.obj.titleEN"
                >
                  <template #label>
                    {{ $t(`table.title`) + " (EN)" }}
                    <span class="red--text"><b>*</b></span>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols :sm="6" class="py-0">
                <v-typeDiscovery
                  v-model="Discovery.obj.type"
                  :rules="[Rules.required]"
                />
              </v-col>
              <v-col cols :sm="6" class="py-0">
                <v-statusDiscovery
                  v-model="Discovery.obj.status"
                  :rules="[Rules.required]"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols :sm="6" class="py-0">
                <v-text-field
                  color="primary"
                  type="number"
                  :rules="[Rules.required, Rules.number]"
                  v-model="Discovery.obj.priority"
                >
                  <template #label>
                    {{ $t(`table.priority`) }}
                    <span class="red--text"><b>*</b></span>
                  </template>
                </v-text-field>
              </v-col>
              <v-col
                cols
                :sm="6"
                class="py-5"
                v-if="_fnHideAuto(Discovery.obj.type)"
              >
                <v-checkbox
                  color="primary"
                  :label="$t(`table.isAuto`)"
                  hide-details
                  v-model="Discovery.obj.isAuto"
                ></v-checkbox>
              </v-col>
            </v-row>
            <div
              v-if="_fnHideAuto(Discovery.obj.type) && !Discovery.obj.isAuto"
            >
              <h3 class="black--text py-3">
                {{
                  `${$t(`table.listChoice`)} (${Discovery.obj.list.length}/30)`
                }}
              </h3>
              <v-row>
                <v-col cols :sm="6" class="py-0">
                  <v-text-field color="primary" v-model="idPick">
                    <template #label>{{ "Enter ID" }}</template>
                  </v-text-field>
                </v-col>
                <v-col cols :sm="6" class="py-3">
                  <v-btnc
                    :size="30"
                    icon="mdi-plus"
                    :disabled="
                      !idPick ||
                      idPick.length != 24 ||
                      Discovery.obj.list.length >= 30
                    "
                    @click="_fnAddItem()"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols :sm="12" class="py-0">
                  <v-data-table
                    :items="Discovery.obj.list"
                    :headers="cTableHeaders"
                    :items-per-page="5"
                    item-key="item.id"
                    dense
                  >
                    <template #[`item.item.image`]="{ item }">
                      <v-upload
                        :size="30"
                        class="py-1"
                        v-model="item.item.image"
                        :readonly="true"
                      />
                    </template>
                    <template #[`item.priority`]="{ item }">
                      <v-text-field
                        color="primary"
                        type="number"
                        v-model="item.priority"
                      />
                    </template>
                    <template #[`item.action`]="{ item }">
                      <v-btnc
                        :size="30"
                        color="error"
                        icon="mdi-delete"
                        @click="_fnDelItem(item.item.id)"
                      />
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </div>
          </v-card-text>
          <v-card-actions class="px-4">
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              :disabled="
                !Discovery.isValid ||
                (!Discovery.obj.isAuto && !Discovery.obj.list.length)
              "
              @click="Discovery.isCreate ? _fnCreate() : _fnUpdate()"
              >{{
                Discovery.isCreate ? $t(`table.create`) : $t(`table.update`)
              }}
            </v-btn>
            <v-btn outlined color="primary" @click="_fnReset()">
              {{ $t(`table.cancel`) }}
            </v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-col>

    <v-dialog
      v-if="Discovery.isDelete"
      v-model="Discovery.isDelete"
      persistent
      scrollable
      max-width="500"
    >
      <v-card>
        <v-card-title dense class="headline primary" />
        <v-card-text class="pt-2">
          {{ $t(`table.deleteMess`) }}
          <b>{{ Discovery.obj.title }}</b>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" @click="_fnDelete()">
            {{ $t(`table.delete`) }}
          </v-btn>
          <v-btn outlined color="primary" @click="_fnReset()">
            {{ $t(`table.cancel`) }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  data: () => ({
    model: "Discovery",
    idPick: null,
    cTableHeaders: [],
  }),
  created() {
    this.cTableHeaders = [
      {
        text: this.$t(`table.id`),
        value: "item.id",
        width: "130px",
      },
      {
        text: this.$t(`table.image`),
        value: "item.image",
        width: "130px",
      },
      {
        text: this.$t(`table.name`),
        value: "item.name",
      },
      {
        text: this.$t(`table.priority`),
        value: "priority",
        width: "130px",
      },
      {
        text: this.$t(`table.action`),
        value: "action",
        width: "130px",
      },
    ];
  },
  methods: {
    _fnReset() {
      if (this.$refs.form) this.$refs.form.reset();
      this.fnResetFlagView(this.model);
    },
    _fnReFresh() {
      this._fnReset();
      this[this.model].isRefresh = true;
    },
    async _fnCreate() {
      this[this.model].obj.list = this[this.model].obj.list.map((e) => ({
        item: e.item.id,
        priority: e.priority,
      }));
      const { code } = await this.fnPost({
        url: `/v1/admin/discovery`,
        model: this.model,
      });
      if (code === 200) {
        this._fnReFresh();
      }
    },
    async _fnUpdate() {
      this[this.model].obj.list = this[this.model].obj.list.map((e) => ({
        item: e.item.id,
        priority: e.priority,
      }));
      const { code } = await this.fnPut({
        url: `/v1/admin/discovery/${this[this.model].obj.id}`,
        model: this.model,
      });
      if (code === 200) {
        this._fnReFresh();
      }
    },
    async _fnDelete() {
      const { code } = await this.fnDelete({
        url: `/v1/admin/discovery/${this[this.model].obj.id}`,
        model: this.model,
      });
      if (code === 200) {
        this._fnReFresh();
      }
    },
    _fnHideAuto(type) {
      const arr = ["6258de860d9160ca0d45e026", "6258de860d9160ca0d45e027"];
      return !arr.includes(type);
    },
    async _fnAddItem() {
      const type = {
        "6209ccd497e3e72f60224943": "post",
        "6209ccd497e3e72f60224944": "user",
        "6209ccd497e3e72f60224945": "topic",
        "6209ccd497e3e72f60224946": "gift",
        "6209ccd497e3e72f60224947": "banner",
      };
      const typ = type[this[this.model].obj.type];
      const { code, data, message } = await this.fnGet({
        url: `/v1/admin/${typ}/discovery/${this.idPick}`,
        model: "DiscoveryPick",
      });
      if (code === 200) {
        const idx = this[this.model].obj.list.findIndex(
          (e) => e.item.id == this.idPick
        );
        if (idx == -1) {
          const { id, name, image } = data;
          this[this.model].obj.list.unshift({
            item: { id, name, image },
            priority: 1,
          });
        } else {
          this.fnNotificationView({
            type: "error",
            message: this.$t("table.alreadyExists"),
          });
        }
        this.idPick = null;
      } else {
        this.fnNotificationView({ type: "error", message: message });
      }
    },
    async _fnDelItem(id) {
      this[this.model].obj.list = this[this.model].obj.list.filter(
        (e) => e.item.id != id
      );
    },
  },
};
</script>
